/** Shared CSS + tilt handlers for tour party member cards (web). */

export function getMemberCardEffectCss(isDarkMode = true) {
  const glassBg = isDarkMode
    ? 'linear-gradient(145deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0.02) 42%, rgba(0,0,0,0.12) 100%)'
    : 'linear-gradient(145deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.72) 50%, rgba(0,0,0,0.04) 100%)';

  return `
    .vrc-member-card-shell {
      position: relative;
      overflow: hidden;
      transform-style: preserve-3d;
      will-change: transform;
      transition: transform 0.2s ease-out, box-shadow 0.25s ease;
      cursor: default;
      background: ${glassBg};
      backdrop-filter: blur(22px) saturate(165%);
      -webkit-backdrop-filter: blur(22px) saturate(165%);
      border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.10)'};
      border-radius: 12px;
      box-shadow: ${isDarkMode ? '0 10px 36px rgba(0,0,0,0.38)' : '0 10px 36px rgba(0,0,0,0.08)'};
    }
    .vrc-member-card-shell[data-clickable="true"] {
      cursor: pointer;
    }
    .vrc-member-card-shell:hover {
      box-shadow: ${
        isDarkMode
          ? '0 12px 32px rgba(0,0,0,0.42), 0 0 0 1px rgba(255,255,255,0.06)'
          : '0 12px 32px rgba(0,0,0,0.10), 0 0 0 1px rgba(0,0,0,0.05)'
      };
    }
    .vrc-member-card-glimmer {
      position: absolute;
      inset: 0;
      pointer-events: none;
      z-index: 1;
      opacity: 0;
      background: linear-gradient(
        105deg,
        transparent 35%,
        rgba(255,255,255,${isDarkMode ? '0.10' : '0.22'}) 50%,
        transparent 65%
      );
      background-size: 220% 100%;
      background-position: 120% 0;
    }
    .vrc-member-card-shell:hover .vrc-member-card-glimmer {
      animation: vrc-member-shimmer-hover 1.6s ease-out 1;
    }
    @keyframes vrc-member-shimmer-hover {
      0% { opacity: 0; background-position: 120% 0; }
      15% { opacity: 0.7; }
      100% { opacity: 0; background-position: -120% 0; }
    }
    .vrc-writer-member.vrc-member-card-shell {
      display: block;
      padding: 0;
      overflow: hidden;
      margin: 10px 0;
    }
    .vrc-writer-member-body {
      position: relative;
      z-index: 2;
      padding: 10px 12px;
    }
    .vrc-writer-member-controls {
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 4;
      display: flex;
      gap: 4px;
      opacity: 1;
    }
    .vrc-writer-member:hover .vrc-writer-member-controls {
      opacity: 1;
    }
    .vrc-writer-member-drag,
    .vrc-writer-member-remove {
      border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.14)' : 'rgba(0,0,0,0.12)'};
      background: ${isDarkMode ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.92)'};
      color: ${isDarkMode ? '#fff' : '#111'};
      border-radius: 6px;
      width: 24px;
      height: 24px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      line-height: 1;
      cursor: pointer;
      padding: 0;
    }
    .vrc-writer-member-drag {
      cursor: grab;
      letter-spacing: -1px;
    }
    .vrc-writer-member-drag:active {
      cursor: grabbing;
    }
    .vrc-writer-member-remove {
      font-size: 16px;
      font-weight: 700;
    }
    .vrc-writer-member-dragging {
      opacity: 0.55;
    }
    .vrc-writer-member-drop-target {
      outline: 2px dashed ${isDarkMode ? 'rgba(151,255,17,0.55)' : 'rgba(78,125,224,0.55)'};
      outline-offset: 2px;
    }
    .vrc-writer-member-header {
      display: flex;
      align-items: flex-start;
      gap: 10px;
    }
    .vrc-writer-member-photo {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      object-fit: cover;
      border: 1.5px solid ${isDarkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'};
      flex-shrink: 0;
    }
    .vrc-writer-member-photo-fallback {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: ${isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'};
      color: ${isDarkMode ? '#fff' : '#111'};
      font-weight: 800;
      font-size: 16px;
    }
    .vrc-writer-member-info {
      flex: 1;
      min-width: 0;
    }
    .vrc-writer-member-name {
      font-weight: 800;
      font-size: 14px;
      line-height: 1.2;
    }
    .vrc-writer-member-email {
      font-size: 10px;
      opacity: 0.65;
      margin-top: 2px;
    }
    .vrc-writer-member-type {
      display: inline-block;
      font-size: 10px;
      font-weight: 700;
      padding: 2px 8px;
      border-radius: 999px;
      border: 1px solid;
      margin-top: 5px;
    }
    .vrc-writer-member-role {
      display: inline-block;
      font-size: 10px;
      font-weight: 700;
      opacity: 0.75;
      margin-top: 5px;
    }
    .vrc-writer-link-btn {
      display: inline-block;
      padding: 9px 16px;
      border-radius: 10px;
      background: linear-gradient(135deg, #578dff 0%, #4e7de0 100%);
      color: #fff !important;
      text-decoration: none;
      font-weight: 800;
      font-size: 13px;
      margin: 6px 0;
      box-shadow: 0 6px 18px rgba(78, 125, 224, 0.35);
    }
    .vrc-writer-link-btn:hover {
      filter: brightness(1.06);
    }
  `;
}

let injected = false;

export function injectMemberCardEffectStyles(isDarkMode = true) {
  if (typeof document === 'undefined') return;
  const existing = document.querySelector('[data-vrc-member-card]');
  if (existing) existing.remove();
  injected = true;
  const el = document.createElement('style');
  el.setAttribute('data-vrc-member-card', 'true');
  el.textContent = getMemberCardEffectCss(isDarkMode);
  document.head.appendChild(el);
}

function applyTilt(card, event) {
  const rect = card.getBoundingClientRect();
  const px = (event.clientX - rect.left) / rect.width - 0.5;
  const py = (event.clientY - rect.top) / rect.height - 0.5;
  const rotateY = px * 4;
  const rotateX = -py * 3;
  card.style.transform = `perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.004)`;
}

function resetTilt(card) {
  card.style.transform = 'perspective(800px) rotateX(0deg) rotateY(0deg) scale(1)';
}

/** Mouse-tilt for member cards inside a root element (editor, preview, etc.). */
export function attachMemberCardTiltHandlers(rootEl) {
  if (!rootEl || typeof rootEl.addEventListener !== 'function') return () => {};
  let activeCard = null;

  const onMove = (event) => {
    const card = event.target?.closest?.('.vrc-member-card-shell');
    if (!card || !rootEl.contains(card)) {
      if (activeCard) resetTilt(activeCard);
      activeCard = null;
      return;
    }
    if (activeCard && activeCard !== card) resetTilt(activeCard);
    activeCard = card;
    applyTilt(card, event);
  };

  const onLeave = () => {
    if (activeCard) resetTilt(activeCard);
    activeCard = null;
  };

  rootEl.addEventListener('mousemove', onMove);
  rootEl.addEventListener('mouseleave', onLeave);
  return () => {
    rootEl.removeEventListener('mousemove', onMove);
    rootEl.removeEventListener('mouseleave', onLeave);
    if (activeCard) resetTilt(activeCard);
  };
}

export function bindMemberCardShellTilt(shellEl, onMouseLeave) {
  if (!shellEl) return () => {};
  const onMove = (event) => applyTilt(shellEl, event);
  const onLeave = () => {
    resetTilt(shellEl);
    onMouseLeave?.();
  };
  shellEl.addEventListener('mousemove', onMove);
  shellEl.addEventListener('mouseleave', onLeave);
  return () => {
    shellEl.removeEventListener('mousemove', onMove);
    shellEl.removeEventListener('mouseleave', onLeave);
    resetTilt(shellEl);
  };
}
